module.exports = __webpack_public_path__ + "img/sup_deposit_bank_3.9e17647a.png";